import type { ReactNode } from 'react';
import {
  AttachmentToolbarButton,
  LexicalMarkdownEditor,
  type AttachmentUploadState,
} from '@/shared/ui/primitives/lexical-markdown-editor';
import { Textarea } from '@/shared/ui/shadcn/textarea';

import styles from './DocumentEditorWorkspace.module.css';

interface DocumentEditorPageProps {
  mode: 'visual' | 'markdown';
  documentMarkdown: string;
  onChange(documentMarkdown: string): void;
  onUploadAttachment(file: File): void | Promise<void>;
  uploadState: AttachmentUploadState;
  placeholder?: string;
  plugins?: ReactNode;
  formatMarkdown?(markdown: string): string;
}

export function DocumentEditorPage({
  mode,
  documentMarkdown,
  onChange,
  onUploadAttachment,
  uploadState,
  placeholder = 'Start writing…',
  plugins,
  formatMarkdown = (markdown) => markdown,
}: DocumentEditorPageProps) {
  return (
    <div className={styles.documentEditor} aria-label="Document">
      {mode === 'visual' ? (
        <LexicalMarkdownEditor
          value={documentMarkdown}
          onChange={onChange}
          placeholder={placeholder}
          namespace="DocumentEditor"
          toolbarItems={
            <AttachmentToolbarButton onUpload={onUploadAttachment} uploadState={uploadState} />
          }
          plugins={plugins}
          className={styles.documentPage}
        />
      ) : (
        <Textarea
          value={documentMarkdown}
          onChange={(event) => onChange(formatMarkdown(event.target.value))}
          className={styles.documentPage}
          aria-label="Document Markdown"
        />
      )}
    </div>
  );
}
